//
//
//
//
//
//
export default {
  name: "wart"
};